<div id="post" class="content is-medium">
{#if $id && $snippets.length > 0}
  <h1>{$snippets[$id].title}</h1> 
  <!-- {#if $snippets[$id].img}
  <img src="../img/{$snippets[$id].img}.png" />
  {/if} -->

  <h2>{$snippets[$id].desc}</h2>

  <Runkit code={$snippets[$id].code} title={$snippets[$id].title} />

{:else}
  <h1>Cannot find this snippet!</h1>
{/if}

</div>

<style type="text/sass">
  /* @import "../../styles/_variables"; */
  h1 {
		padding: 10px;
	}
  .content {
	padding-top:20px;
}

</style>


 <script >


//>{@html snippets[id].code}

  export default {
    store: () => store,
    components:{ Runkit
     
    },
    methods: {
       
    },
  
	oncreate() {

	}
  }
</script>

